export default __webpack_public_path__ + "static/media/6.40e4a632.jpg";